import ReactVisibilitySensor from "react-visibility-sensor"
import ImageAndBoxSectionPropsType from "../../../types/ImageAndBoxPropsType"
import { useContext } from "react"
import { LangContext, PageContext } from "../../../App"

const ImageAndBoxSection = ({
    title = "Box title",
    subtitle = 'box subtitle',
    image,
    button,
} : ImageAndBoxSectionPropsType) => {
    const pageContext = useContext(PageContext);
    const { lang } = useContext(LangContext);

  return (
    <div className="image-and-box-section">
        <img src={image.src} className="section-image" alt={image?.alt} />
        <div className="box-container">
            {/* <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => ( */}
                <div className={`section-box an-move-top`}>
                    <h3 className="title">{title}</h3>
                    <p className="subtitle">{subtitle}</p>
                    <button 
                        className="button"
                        onClick={() => pageContext.handleChangePage(button.path)}
                        aria-label={(!lang ? "Read more about " : "أقرأ المزيد عن ") + title}
                        title={(!lang ? "Read more about " : "أقرأ المزيد عن ") + title}
                    >{button.text}</button>
                </div>
            {/* )}
            </ReactVisibilitySensor> */}
        </div>
    </div>
  )
}

//  ${isVisible ? "an-active" : ""}

export default ImageAndBoxSection